const get = (key) => {
    return process.env[key].trim();
}

export const UtilEnv = {
   get
};